import {
    PAYMENT_INDEX_CHART_TOGGLE_SELECTOR,
    PAYMENT_INDEX_CHART_TOGGLE_DATA_TABLE,
    PAYMENT_INDEX_TOGGLE_TERMINOLOGY,
} from './constants'

export function paymentIndexToggleTerminology(module, id, blockKey, customData) {
    return {
        type: PAYMENT_INDEX_TOGGLE_TERMINOLOGY,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}

export function paymentIndexChartToggleSelector(module, id, blockKey, customData) {
    return {
        type: PAYMENT_INDEX_CHART_TOGGLE_SELECTOR,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}

export function paymentIndexChartToggleDataTable(module, id, blockKey, customData) {
    return {
        type: PAYMENT_INDEX_CHART_TOGGLE_DATA_TABLE,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}
